import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/first_anniversary/kv.jpeg'
import _imports_1 from '@/assets/img/event/ueno/ueno-photograph.png'
import _imports_2 from '@/assets/img/event/first_anniversary/benefits_01.jpeg'
import _imports_3 from '@/assets/img/event/first_anniversary/benefits_02.jpeg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1c96e527")

_pushScopeId("data-v-1c96e527")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "kv",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "main-top" }, [
  /*#__PURE__*/_createVNode("div", { class: "main-top-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "main-top-container-headline" }, "onlylive１周年記念イベント🎉"),
    /*#__PURE__*/_createVNode("p", { class: "main-content-bottom" }, [
      /*#__PURE__*/_createTextVNode("onlyliveリリース１周年を記念して、「onlylive公式CM出演オーディション」を開催します！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("配信時間・人数などに応じて決定されるランキングで1位〜3位の方は、「公式CMメイン出演権」をプレゼント🎁"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("また、条件を達成された方全員に「公式CMサブ出演権」をプレゼント✨")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "photograph" }, [
    /*#__PURE__*/_createVNode("div", { class: "under-circle" }, [
      /*#__PURE__*/_createVNode("img", {
        class: "photograph-circle-img",
        src: _imports_1
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("a", {
    class: "photograph-btn",
    href: "https://onlylive.tokyo/",
    target: "_brank"
  }, [
    /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "onlyliveとは")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "event-info" }, [
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "【開催期間・概要】"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail-date" }, "2022年5月1日（日）00:00:00 ~ 2022年5月14日（土）23:59:59"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "参加資格：年齢、性別不問"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createTextVNode("※本イベントにおいて生じる交通費・宿泊費・出演料の支給はございませんので、予めご了承ください。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※ビジョン広告出演のため、"),
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "顔出しが必要"),
      /*#__PURE__*/_createTextVNode("となります。")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "【ランキングスコアUPキャンペーン】"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "下記の条件をクリアすると、ランキングスコアが合計800スコアもらえるキャンペーンを実施！"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "通話による獲得スコアが2倍になる期間も...✨"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "①スタートダッシュキャンペーン"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "4/24 ~ 30までの7日間"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("配信回数に応じて最大500スコアをイベント開始時にプレゼント！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "②GWラッシュキャンペーン"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "5/3 ~ 5までの3日間"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("通話にて獲得できるスコアが2倍に！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "③ラストスパートキャンペーン"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "5/12 ~ 14までの3日間"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("配信回数に応じて最大300スコアをイベント終了時にプレゼント！")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
      /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
    ]),
    /*#__PURE__*/_createVNode("a", {
      class: "photograph-btn",
      href: "https://onlylive.tokyo/talent#contact",
      target: "_brank"
    }, [
      /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-title" }, "『onlylive１周年記念イベント』"),
    /*#__PURE__*/_createVNode("a", {
      class: "event-info-link",
      href: "#benefits"
    }, "▼オーディション情報はこちら▼")
  ])
], -1)
const _hoisted_5 = { class: "event-ranking-body-section" }
const _hoisted_6 = { class: "ranking-section" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "benefits" }, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-headline" }, "ランキング特典"),
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-caution" }, "エントリー前に必ず日程をご確認ください。"),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("img", {
            class: "rank-banner",
            src: _imports_2
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, "onlyliveの広告タレントとして、上野広小路・御徒町付近の「上野ビジョン広告」へのメイン出演権をプレゼント🎁"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "掲載・掲出期間 2022/7/1 ~ 31 放映予定")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("img", {
            class: "rank-banner",
            src: _imports_3
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, "イベント期間中、条件達成でonlyliveの広告タレントとして、上野広小路・御徒町付近の「上野ビジョン広告」サブ出演権や、Amazonギフト券をプレゼント🎁"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "掲載・掲出期間 2022/7/1 ~ 31 放映予定"),
          /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
            /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
          ]),
          /*#__PURE__*/_createVNode("a", {
            class: "photograph-btn",
            href: "https://onlylive.tokyo/talent#contact",
            target: "_brank"
          }, [
            /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "notes-top-title" }, "注意事項"),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, "・2022年5月1日00時00分00秒以降に通話を開始分から、2022年5月14日23時59分59秒までの通話開始分がランキングに加算されます。"),
      /*#__PURE__*/_createVNode("li", null, "・2022年5月14日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）"),
      /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、2022年5月15日を予定しております。")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2022 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Ranking, {
            event: _ctx.state.event,
            rankingUsers: _ctx.state.ranking,
            getRankingPath: "first_anniversary_ranking",
            getEnableEventPath: "enable_first_anniversary_event",
            isShowAll: true
          }, null, 8, ["event", "rankingUsers"])
        ])
      ]),
      _hoisted_7
    ]),
    _hoisted_8
  ]))
})